import qs from 'qs';

export default function getQueryParams() {
  const params = window.location.href.split('?')[1];
  return qs.parse(params);
}
